module.exports = __webpack_public_path__ + "img/20.fe5e653c.svg";